import _ from 'underscore';

export const inlineDownloadGenericPlugin = definePlugin => definePlugin('inlineDownload', [
  'config',
  'gridView',
  'toolbar',
  'segment',
], (config, gridView, toolbar, segment) => {
  const {
    DownloadView,
    button = 'button-download',
    schema,
    // DEPRECATED: use schema instead
    entity = schema ? schema.name : null,
    gridId,
    cusToolbarItem = {},
    disableOnEmpty = true,
    disableOnTooMuchData = true,
    i18n,
    downloadFormats,
    segmentationTypes,
    isFeedbackEnabled,

    p$daterange,
  } = config.plugins.inlineDownload;

  let { isAvailable } = config.plugins.inlineDownload;
  let downloadView = null;
  const toolbarEditor = config.plugins.inlineDownload.toolbar ||
    toolbar.gridToolbarGroup.toolbarWithItem(button);

  function createDownloadView(ReportRule) {
    const selectedColumns = gridView.get('columns');

    downloadView = new DownloadView({
      selectedColumns,

      downloadFormats,
      segmentationTypes: segmentationTypes || segment.getAvailableSegmentationTypes(),
      entity,
      gridId,
      totalRecordCount: gridView.getItemCount(),
      validateSegmentType: segment.validateSegmentType,
      isFeedbackEnabled,
      data: ReportRule,

      isForVNext: true,
      p$daterange,
    }).render();

    return downloadView;
  }

  function showDownloadView(ReportRule) {
    if (!downloadView) {
      createDownloadView(ReportRule);
    }

    toolbarEditor.overrideWith(downloadView);
    toolbar.gridToolbarGroup.hideAllToolbars();

    // Use 'once' instead 'on'
    //  * The 'showToolbar' event should only be handled once, then the view
    //    is destroyed.
    //  * The current implementation of DownloadView.clear triggers 'showToolbar',
    //    which would cause dead loop if we use 'on'
    downloadView.once('showToolbar', () => {
      toolbarEditor.restoreToolbar();
      toolbar.gridToolbarGroup.showAllToolbars();
      downloadView = null;

      toolbarEditor.overrideWith(null);
    });
  }

  toolbarEditor.update(_.defaults(cusToolbarItem, {
    id: button,
    classes: '',
    iconLeft: '',
    text: i18n.getString('InlineReportDownload_Download_Button'),
    disabled: !isAvailable,
    onClick: () => showDownloadView({
      SegmentationTypes: (() => {
        const segmentationType = segment.getSegmentType();

        return segmentationType ? [segmentationType] : [];
      })(),
    }),
  }));

  /*
   * in new ui, we only disable when there is too much data.
   * MT doesn't support download call and will throw exception.
   * The Check disableOnEmpty is to be compatible with old behavior.
   */
  if (disableOnEmpty && disableOnTooMuchData) {
    let isTooMuchDataInGrid = false;

    gridView.on('didReload', (succeeded, data = {}) => {
      if (!succeeded) {
        if (_.any(data.errors, err => err.Code === 'TooMuchDataToDownload')) {
          isTooMuchDataInGrid = true;
        }
      }
    });

    gridView.on('didUpdate', () => {
      if (isTooMuchDataInGrid) {
        toolbarEditor.set(button, {
          disabled: isTooMuchDataInGrid,
        });
      }
    });
  }

  function remove() {
    if (downloadView) {
      downloadView.remove();
    }
  }

  return {
    remove,
    getAvailability() {
      return isAvailable;
    },
    setAvailability(isAvailableNew) {
      isAvailable = isAvailableNew;

      toolbarEditor.update({
        id: button,
        disabled: !isAvailable,
      });
    },
    getDownloadView() {
      return downloadView;
    },
    showDownloadView,
  };
});
